import React, { MouseEventHandler } from "react";

//Declare the button's prop types
type ButtonProps = {
  title: string;
  onClick?: MouseEventHandler;
};

const Button = ({ title, onClick }: ButtonProps) => {
  return (
    <button
      className="h-10 px-6 font-semibold rounded-md bg-black text-white m-2 hover:animate-wiggle"
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export { Button };
